export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://phalanxresearch.com';

export const SITE_NAME = 'Phalanx';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/phalanx-logo.png`;

export const TWITTER_HANDLE = '@researchphalanx';

export const ORGANIZATION = {
  name: 'Phalanx',
  legalName: 'Northlight Technologies',
  url: SITE_URL,
  logo: `${SITE_URL}/phalanx-logo.png`,
  email: 'Contact@researchphalanx.com',
};

export const PUBLIC_STATIC_ROUTES = [
  { path: '/', changefreq: 'weekly', priority: '1.0' },
  { path: '/research', changefreq: 'monthly', priority: '0.9' },
  { path: '/sovra', changefreq: 'monthly', priority: '0.5' },
  { path: '/sectrace', changefreq: 'weekly', priority: '0.6' },
  { path: '/sectrace/research', changefreq: 'monthly', priority: '0.6' },
  { path: '/pbi', changefreq: 'yearly', priority: '0.3' },
];

export const NOINDEX_ROUTES = [
  '/login',
  '/dashboard',
  '/analysis',
  '/activists',
  '/reports',
  '/performance',
  '/add-report',
  '/twitter-feed',
  '/subscriptions',
];

export function absoluteUrl(path) {
  if (!path) return SITE_URL;
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function buildReportPath(activist, reportTitle) {
  return `/report/${encodeURIComponent(activist)}/${encodeURIComponent(reportTitle)}`;
}

export function buildActivistPath(name) {
  return `/activist/${encodeURIComponent(name)}`;
}

export function buildCanonicalUrl(pathname, { stripQuery = true } = {}) {
  const base = absoluteUrl(pathname);
  if (stripQuery) return base.split('?')[0];
  return base;
}
